import { doc, getDoc } from "firebase/firestore";
import { db } from "./firestore.js";

export async function getRole(user) {
  if (!user) return null;
  const snap = await getDoc(doc(db, `users/${user.uid}`));
  return snap.data()?.role ?? null;
}
